import { createActionsHook, createHook, createStore } from 'react-sweet-state';

export type Menu = 'conversation-list' | 'agents' | 'none';

type State = {
	activeMenu: Menu;
	mounted: boolean;
	isAgentSelectorMenuOpen: boolean;
	streaming: boolean;
	isSideNavOpen: boolean;
};

const initialState: State = {
	activeMenu: 'none',
	mounted: false,
	isAgentSelectorMenuOpen: false,
	streaming: false,
	isSideNavOpen: false,
};

const store = createStore({
	name: 'uiStore',
	initialState,
	actions: {
		// created for resetting store during tests
		reset:
			() =>
			({ setState }) => {
				setState({
					...initialState,
				});
			},
		setActiveMenu:
			(menu: Menu) =>
			({ setState }) => {
				setState({ activeMenu: menu });
			},
		setMounted:
			(mounted: boolean) =>
			({ setState }) => {
				setState({ mounted });
			},
		setIsAgentSelectorMenuOpen:
			(isOpen: boolean) =>
			({ setState }) => {
				setState({ isAgentSelectorMenuOpen: isOpen });
			},
		setStreamingStatus:
			(status: boolean) =>
			({ setState }) => {
				setState({ streaming: status });
			},
		setSideNavOpen:
			(isOpen: boolean) =>
			({ setState }) => {
				setState({ isSideNavOpen: isOpen });
			},
	},
});

const useStore = createHook(store);

export const useUIStore = () => {
	const [
		{ activeMenu, mounted, streaming, isAgentSelectorMenuOpen, isSideNavOpen },
		{
			reset,
			setActiveMenu,
			setMounted,
			setIsAgentSelectorMenuOpen,
			setStreamingStatus,
			setSideNavOpen,
		},
	] = useStore();

	return {
		activeMenu,
		mounted,
		streaming,
		isAgentSelectorMenuOpen,
		isSideNavOpen,
		reset,
		setActiveMenu,
		setMounted,
		setIsAgentSelectorMenuOpen,
		setStreamingStatus,
		setSideNavOpen,
	};
};

export const useUIStoreActions = createActionsHook(store);
